export default __webpack_public_path__ + "static/pwa-trend-sviluppo-software-b0c2200f78faba376ca5e8b429b1e703.jpg";